import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;

    > span {
      color: ${theme.colors.error};
    }

    .ant-radio-group {
      display: none;
    }
  `}
`;

export const Header = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: 1px solid ${theme.colors.transactionSecondary};
    padding: 0.5rem;
    cursor: pointer;

    > p {
      color: ${theme.colors.primary};
      margin: 0;
    }

    svg {
      color: ${theme.colors.primary};
    }
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    position: absolute;
    background-color: ${theme.colors.darkWhite};

    .ant-picker-panel {
      position: relative;
      z-index: 2;
    }
  `}
`;
